import React from 'react'
import { ScrollView } from 'react-native'
import { useStores } from '../../data/store'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { DropdownList } from '../DropDownList'

const listViewWithoutPopularBanks = React.forwardRef(({ children, ...props }: any, ref: any) => {
  const { getInstrumentsList, setSelectedPayment } = useStores((root) => ({
    getInstrumentsList: root.getInstrumentsList,
    setSelectedPayment: root.setSelectedPayment,
  }))

  const { type, selectedItem, setSelectedItem, validateOfferState, applyOfferState, onClickPay, convFeeComp, amount } =
    props

  const instruments = getInstrumentsList(type)
  const otherKey = type === PAYMENT_MODE_SUBTYPES.NB || PAYMENT_MODE_SUBTYPES.CORP_NB ? 'Other banks' : 'Other Wallets'
  const otherBanks = instruments?.find((item: any) => item.title === otherKey) ?? []

  const setSelection = (value: string) => {
    setSelectedItem(otherBanks.data.find((item: any) => item?.text === value)?.id)
  }

  const getSelectedvalue = () => {
    const selectedBank = otherBanks.data?.find((item: any) => item.id === selectedItem)
    return selectedBank?.text ?? ''
  }

  const onClickPaySecure = () => {
    setSelectedPayment(selectedItem, type)
    onClickPay()
  }

  return (
    <ScrollView
      {...props}
      ref={ref}
      scrollEventThrottle={10}
      onScroll={(e) => {
        props.onScroll(e)
      }}
      contentContainerStyle={{
        flex: 1,
      }}>
      <>
        {convFeeComp && convFeeComp}
        <DropdownList
          data={otherBanks?.data ?? []}
          type={type}
          label={
            type === PAYMENT_MODE_SUBTYPES.NB || type === PAYMENT_MODE_SUBTYPES.CORP_NB ? 'All Banks' : 'All Wallets'
          }
          placeHolder={
            type === PAYMENT_MODE_SUBTYPES.NB || type === PAYMENT_MODE_SUBTYPES.CORP_NB
              ? 'Select your bank'
              : 'Select your wallet'
          }
          onChange={setSelection}
          value={getSelectedvalue()}
          isModalSizeFixed={true}
          modalPosition={'BottomTop'}
          displayPayButton={true}
          setSelectedItem={setSelectedItem}
          onClickPaySecure={onClickPaySecure}
          isLoading={validateOfferState === 'pending' || applyOfferState === 'pending'}
          convFeeComp={convFeeComp}
          amount={amount}
        />
      </>
      {children}
    </ScrollView>
  )
})

export { listViewWithoutPopularBanks }
